export default (x = 0, y = 0, z = 0) => {
  const translateCSS = `translate3d(${x}px, ${y}px, ${z}px)`;

  return {
    transform: translateCSS,
    WebkitTransform: translateCSS,
    msTransform: translateCSS,
  };
};
